import React, { useState } from 'react';
import { Element } from 'react-scroll';
import { Collapse } from 'reactstrap';
import { useDesktop } from '../hooks';

const desktopClassName = (desktop: boolean): string =>
  desktop ? 'container-fluid bg-white pt30 pb30' : 'container-fluid bg-white';

const notCoverClassName = (collapse: boolean): string =>
  collapse
    ? 'col-12 border-bottom pt30 pb30 d-block d-md-none mb20'
    : 'col-12 border-bottom pt30 pb30 d-block d-md-none';

export default function ProductNotCover() {
  const desktop = useDesktop();
  const [collapse, setCollapse] = useState(desktop);

  const toggle = () => setCollapse(!collapse);

  return (
    <div className={desktopClassName(desktop)}>
      <div className="container">
        <div className="row">
          <div
            className={notCoverClassName(collapse)}
            onClick={toggle}
            role="presentation"
          >
            <i className="material-icons align-middle">keyboard_arrow_right</i>
            ¿Qué no cubre?
          </div>
          <Collapse className="col-12" isOpen={collapse}>
            <Element name="notCover" className="col-12">
              <h2 className="px-24 text-center mb40">¿Qué no cubre?</h2>
            </Element>
            <div className="col-12 text-center px-16 text-bold">
              <p>Principales exclusiones</p>
            </div>
            <ul className="col-12 col-sm-10 d-flex flex-wrap text-primary mx-auto mb0 li-custom li-cross">
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Condiciones y Padecimientos Preexistentes.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                  Fármacos no prescritos por un médico.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Práctica profesional de cualquier deporte
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Estado etílico ó uso de estupefacientes
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Accidentes bajo el efecto de alcohol, drogas, enervantes o alucinógenos
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Conductor o pasajero de motocicletas, motonetas, cuatrimotos ú otros vehículos similares.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Aviación privada, en calidad de piloto, pasajero, mecánico o miembro de la tripulación.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Paracaidismo, charrería, esquí, tauromaquia, alpinismo, buceo y deportes aéreos.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Actos delictivos intencionales, rebelión o insurrección, así como actos de guerra y servicios militares.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Maternidad y sus complicaciones salvo como consecuencia de un accidente.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Tratamientos dentales, alveolares, gingivales ó de carácter estético salvo que sean como consecuencia de un accidente cubierto.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                SIDA ó VIH y todas las enfermedades que sean causadas por y/ó relacionadas con el virus del VIH.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Tratamientos ó intervención quirúrgica debidos a amigdalitis, adenoiditis o hernias, salvo que el asegurado haya estado amparado ininterrumpidamente durante los 4 meses previos a la fecha en que se practique la intervención o tratamiento.
                </p>
              </li>
              <li className="col-12 col-sm-6">
                <p className="text-dark-gray">
                Tratamientos de enfermedades que son transmitidas sexualmente
                </p>
              </li>
            </ul>
          </Collapse>
        </div>
      </div>
    </div>
  );
}
